import { Button, Input, Select, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import axios from 'axios';
import React, { useState ,useEffect } from 'react'
import { toast } from 'react-toastify';
import { MachineMasterDelete, MachineMasterGet, MachineMasterSave, MachineMasterUpdate } from '../../../AllAPI/MasterAPI/ProductionMasterApi';
import "../../MainCSS.css";
import "aos/dist/aos.css";



const MachineMaster = () => {
  const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  };

  const [errors, setErrors] = useState({
    machineName: "",
    description: "",
     stat:"",
  });

  const [pageSize, setPageSize] = useState(10);
  const [filteredData, setFilteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalEntries, setTotalEntries] = useState(0);

  const [machineId, setMachineId] = useState("");
  const [machineName, setMachineName] = useState("");
  const [description, setDescription] = useState("");
  const [stat, setStat] = useState("");
  const [allMachine, setAllMachine] = useState([]);
  const [submitButton, setSubmitButton] = useState(true);
  const [updateButton, setUpdateButton] = useState(false);

  //======Search data from table===============
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = allMachine.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };

  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value);
  };

  // ==============Get table data================
  let isMachineMAsterFetched = false;
  useEffect(() => {
    if (isMachineMAsterFetched) return;
        fetchMachineMaster();
    isMachineMAsterFetched = true;
  }, []);

  let isError = false;

  const fetchMachineMaster = async () => {
    try {
      const response = await axios.get(MachineMasterGet ,commonHeaders);
      if (response.data !== null) {
        setAllMachine(response.data);
        setFilteredData(response.data); // Set initial filtered data as the fetched data
        setTotalEntries(response.data.length); // Set the total number of entries
      }
    } catch (error) {
      if (!isError) {
        console.error("Error fetching Machine Master data:", error);
        toast.error("Failed to fetch Machine Master data");
        isError = true; // Set the flag to prevent double toast
      }
    }
  };

  // const columns = [
  //   {
  //     title: "Sr.No.",
  //     dataIndex: "",
  //     key: "index",
  //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //   },
 
  //   {
  //     title:"Machine Name",
  //     dataIndex: "machineName",
  //     key: "machineName",
  //      sorter: (a, b) => a.machineName?.localeCompare(b.machineName),
  //   },
  //   {
  //     title: "Description",
  //     dataIndex: "description",
  //     key: "description",
  //      sorter: (a, b) => a.description?.localeCompare(b.description),
  //   },
  //   {
  //     title: "Status",
  //     dataIndex: "status",
  //     key: "status",
  //     render: (stat) => (stat === 1 ? "Active" : "Inactive"),
  //   },
  //   {
  //     title: "Actions",
  //     key: "actions",
  //     render: (text, record) => (
  //       <div>
  //         <span
  //           type="submit"
  //           style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
  //           onClick={() => handleEditDataButton(record)}
  //         >
  //           <i class="fa-solid fa-pen-to-square"></i>
  //         </span>
  //         <span
  //           type="submit"
  //           style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
  //           onClick={() => handleDeleteData(record)}
  //         >
  //           <i class="fa-solid fa-trash"></i>
  //         </span>
  //       </div>
  //     ),
  //   },
  // ];

  const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Machine Name",
    dataIndex: "machineName",
    key: "machineName",
    sorter: (a, b) => a.machineName?.localeCompare(b.machineName),
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    sorter: (a, b) => a.description?.localeCompare(b.description),
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (stat) => (stat === 1 ? "Active" : "Inactive"),
    sorter: (a, b) => a.status - b.status, // 0 before 1 => Inactive before Active
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
          onClick={() => handleEditDataButton(record)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
          onClick={() => handleDeleteData(record)}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
];

  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: "#023e7d",
            color: "#fff",
            padding: "10px",
 fontSize: "15px",
             borderRadius: "0px",
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: "#f0f7fd",
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: "8px",
             fontSize: "15px",
          }}
        >
          {children}
        </td>
      ),
    },
  };
// ========Submit data to table==============
    const handleSubmit = async () => {
      let isValid = true;
      const errorObj = {};
  
      if (!machineName.trim()) {
        isValid = false;
        errorObj.machineName = "Machine Name is required *";
      }
      
      if (!description.trim()) {
        isValid = false;
        errorObj.description = "Description is required *";
      }
  
  
      setErrors(errorObj); // Set error messages
  
      if (!isValid) return;
  
      const bodyData = {
        machineName: machineName,
        description:description,
        status:parseFloat(stat),

      };
  
      try {
        const response = await axios.post(MachineMasterSave, bodyData ,commonHeaders);
  
        if (response.data === "CREATED") {
          toast.success("Machine Name added successfully!");
          fetchMachineMaster();
          handleCancel();
        } else if (response.data === "ALREADYEXISTED") {
          toast.warn("Machine Name already exist!");
          //handleCancel();
        }
      } catch (error) {
        console.error("Error during API call:", error);
        toast.error("Error occurred while submitting data");
      }
    };
    //==================== Handle Cancel button =====================
    const handleCancel = () => {
      setUpdateButton(false);
      setSubmitButton(true);
      setDescription("");
      setMachineName("");
      setStat("");
      setErrors("");
    };
  // ========Update data from table============
  const handleEditDataButton = (item) => {
    setUpdateButton(true);
    setSubmitButton(false);
    window.scrollTo(0, 0);
    setMachineName(item.machineName);
    setDescription(item.description);
    setStat(item.status === 1 ? "Active" : "Inactive");
    setMachineId(item.id);
  };
  const handleUpdate = async () => {
    if (!machineName) {
      toast.warn("Please enter a Name!");
      return;
    }
    if (!description) {
      toast.warn("Please enter Description!");
      return;
    }

    const statusValue = stat === "Active" ? 1 : stat === "Inactive" ? 2 : 1; // Ensure valid status value (1 or 2)

   
    const bodyData = {
      id:machineId,
      machineName: machineName,
      description:description,
      status:statusValue,

    };

    try {
     const response = await axios.put(MachineMasterUpdate,bodyData,commonHeaders);
       
      if (response.data === "UPDATED") {
        toast.success("Machine Name updated successfully!");
        fetchMachineMaster();
        handleCancel();
      } else if (response.data === "ALREADYEXISTED") {
        toast.warn("Machine Name already exist!");
        //handleCancel();
      }
    } catch (error) {
      console.error("Error during API call:", error);
      toast.error("Error occurred while updating data");
    }
  };
  //============================== Delete data from table ======================================
  const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the Machine Name "${item.machineName}"?`
    );
    if (!confirmDelete) return;

    try {
      const response = await axios.delete(
        `${MachineMasterDelete}?id=${item.id}`,commonHeaders
      );
      if (response.data === "DELETED") {
        toast.success("Machine deleted successfully!");
        fetchMachineMaster();
        handleCancel();
      }
    } catch (error) {
      console.error("Error during delete operation:", error);
      toast.error("Error occurred while deleting ");
    }
  };
  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
  <div className="col-12">


   <div className="p-0 m-0">
     <div className="row px-md-5 mt-3 p-2 ">
   
      <div className="row p-0 m-0">
      <div className="col-12 col-lg-4"></div>
      <div className="col-12 col-lg-4">
      <div className="row p-0 m-0">
        
   
      <div className="col-12 py-1">
        <label className="labels">Machine Name</label>
        <Input
          value={machineName}
          maxLength="250"
          onChange={(e) => setMachineName(e.target.value)}
          placeholder="Enter Name"
          style={{ width: '100%' }}
        />
        {errors.machineName && <div className="errorField">{errors.machineName}</div>}
      </div>

      <div className="col-12 py-1">
        <label className="labels">Description</label>
        <Input.TextArea
          value={description}
          maxLength="250"
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter description"
          style={{ width: '100%' }}
        />
        {errors.description && <div className="errorField">{errors.description}</div>}
      </div>
      <div className="col-12 py-1">
                        <label className="labels">Status</label>
                        <Select
                          value={stat}
                          onChange={(value) => setStat(value)}
                          showSearch
                          className="w-100"
                          optionFilterProp="children"
                        >
                          <Option value="">Select Status</Option>
                          <Option value="1">Active</Option>
                          <Option value="2">Inactive</Option>
                        </Select>
                        {errors.stat && <div className="errorField">{errors.stat}</div>}
                      </div>
      </div>
            </div>
            <div className="col-12 col-lg-4"></div>
          </div>
        
          <div className="col-12 text-center pt-3">
              <Button
                type="submit"
                className="CancelBtn mx-1"
                 onClick={handleCancel}
              >
                Cancel
              </Button>
              {submitButton && (
                <Button
                  type="submit"
                  className="SubmitBtn mx-1"
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
              )}
              {updateButton && (
                <Button
                  type="submit"
                  className="UpdateBtn mx-1"
                   onClick={handleUpdate}
                >
                  Update
                </Button>
              )}
            </div>
    
         
            <div
            className="col-12 p-0 mt-3"
            style={{ borderBottom: '2px solid rgb(207, 207, 207)' }}
          ></div>
        </div>
    
      {/*================ Table =========================*/}
      <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
        <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
          <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
              <Select
                defaultValue={pageSize}
                onChange={handlePageSizeChange}
                style={{ width: 120, textAlign: "center" }}
              >
                <Option value={10}>10</Option>
                <Option value={20}>20</Option>
                <Option value={30}>30</Option>
              </Select>
            </div>
    
            <div className="pt-4 pt-md-0">
              <Input.Search
                placeholder="Search"
                onSearch={handleSearch}
                style={{ width: 200, marginBottom: 16 }}
              />
            </div>
          </div>
    
          <div style={{ backgroundColor: "white" }}>
            <Table
              bordered
              style={{ padding: "0px 20px", overflowX: "auto" }}
              columns={columns}
              dataSource={filteredData}
              pagination={{
                pageSize: pageSize,
                total: totalEntries,
                showTotal: (total, range) =>
                  `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                current: currentPage,
                onChange: (page) => setCurrentPage(page),
              }}
              showSorterTooltip={false}
              rowKey={(record) => record.id}
              components={components}
            />
          </div>
        </div>
      </div>
    </div>
</div></div>
</div>
  
  )
}

export default MachineMaster